function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "4B3662F4-A6D0-4CD5-8255-E96F544D56BA");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "staffNewBulk",
  transform: "translate(-993.000000, -354.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Banner-critical",
  transform: "translate(981.000000, 346.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(12.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Icon-BG",
  fill: "#FEAD9A",
  cx: 14,
  cy: 14,
  r: 14
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Fill",
  fill: "#FFFFFF",
  cx: 10,
  cy: 10,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,10 C2,8.154 2.635,6.457 3.688,5.103 L14.897,16.312 C13.542,17.365 11.846,18 10,18 C5.589,18 2,14.411 2,10 M16.312,14.897 L5.103,3.688 C6.458,2.635 8.154,2 10,2 C14.411,2 18,5.589 18,10 C18,11.846 17.365,13.543 16.312,14.897 M0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 C4.486,0 0,4.486 0,10",
  id: "Mask",
  fill: "#BF0711"
}))))));

var SvgFeedbackError = function SvgFeedbackError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedbackError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback-error.4a9fa244.svg";
export { ForwardRef as ReactComponent };